module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_115_8.1d1a86b4.pdf";